import { render } from "./ServiceEditor.vue?vue&type=template&id=1de3f1d4"
import script from "./ServiceEditor.vue?vue&type=script&lang=js"
export * from "./ServiceEditor.vue?vue&type=script&lang=js"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__